import { cloneDeep, isNil, isString } from 'lodash';

import dxDropDownBox from 'devextreme/ui/drop_down_box';
import dxList from 'devextreme/ui/list';
import dxSelectBox from 'devextreme/ui/select_box';
import dxTreeView from 'devextreme/ui/tree_view';

import { ILocalizationService } from '@step/vue/src/layouts/types';

import {
	DxMultipleComponentItemType,
	IDxDefaultSettngsOptions, IDxUiComponentItem,
	isDxMultipleComponentItemWithDropDownBox, isDxMultipleComponentItemWithList, isDxMultipleComponentItemWithSelectBox, isDxMultipleComponentItemWithTreeView
} from './types';
import ConfigurationMixins from '../mixins/configurationMixins';
import { DxDropDownBox, DxSelectBox } from 'devextreme-vue';

export function setUpDxDefaultSettings(options: IDxDefaultSettngsOptions) {
	setDxTreeViewDefaults(options);
	setDxDropDownBoxDefault(options);
	setDxSelectBoxDefaults(options);
	setDxListDefaults(options);
}

function setDxDropDownBoxDefault(options: IDxDefaultSettngsOptions) {
	dxDropDownBox.defaultOptions({
		options: {
			displayExpr: (item: string | IDxUiComponentItem | DxMultipleComponentItemType) => {
				const localizationService = options.localizationService;
				if (isString(item))
					return localizationService.translate(item);
				const captionsJoinString = options.captionsJoinString;
				if (isNil(item))
					return '';
				let keys = item as IDxUiComponentItem;
				if (isDxMultipleComponentItemWithDropDownBox(item))
					keys = item.dxDropDownBox;
				const caption = computeCaption(keys, localizationService, captionsJoinString);
				// item.searchCaption = caption;
				return caption;
			},
			onInitialized: (compoennt: DxDropDownBox, element: HTMLElement, model:any ) => ConfigurationMixins.onContentReady(compoennt, element,  model),
			onOpened:(compoennt: DxDropDownBox, element: HTMLElement, model:any ) => ConfigurationMixins.addedEventMouse(compoennt, element,  model),
			showClearButton: true,
			valueExpr: 'id'
		}
	});
}

function setDxListDefaults(options: IDxDefaultSettngsOptions) {
	dxList.defaultOptions({
		options: {
			// displayExpr: (item: string | IDxUiComponentItem | DxMultipleComponentItemType) => {
			// 	const localizationService = options.localizationService;
			// 	if (isString(item))
			// 		return localizationService.translate(item);
			// 	const captionsJoinString = options.captionsJoinString;
			// 	if (isNil(item))
			// 		return '';
			// 	let keys = item as IDxUiComponentItem;
			// 	if (isDxMultipleComponentItemWithList(item))
			// 		keys = item.dxList;
			// 	return computeCaption(keys, localizationService, captionsJoinString);
			// },
			searchEnabled: true,
			searchMode: 'contains'
			// searchExpr: 'searchCaption'
		}
	});
}

function setDxSelectBoxDefaults(options: IDxDefaultSettngsOptions) {
	dxSelectBox.defaultOptions({
		options: {
			// displayExpr: (item: string | IDxUiComponentItem | DxMultipleComponentItemType) => {
			// 	const localizationService = options.localizationService;
			// 	if (isString(item))
			// 		return localizationService.translate(item);
			// 	const captionsJoinString = options.captionsJoinString;
			// 	if (isNil(item))
			// 		return '';
			// 	let keys = item as IDxUiComponentItem;
			// 	if (isDxMultipleComponentItemWithSelectBox(item))
			// 		keys = item.dxSelectBox;
			// 	const caption = computeCaption(keys, localizationService, captionsJoinString);
			// 	// item.searchCaption = caption;
			// 	return caption;
			// },
			showClearButton: true,
			searchEnabled: true,
			onInitialized: (compoennt: DxDropDownBox, element: HTMLElement, model:any ) => ConfigurationMixins.onContentReady(compoennt, element,  model),
			onOpened:(compoennt: DxDropDownBox, element: HTMLElement, model:any ) => ConfigurationMixins.addedEventMouse(compoennt, element,  model)
		}
	});
}

function setDxTreeViewDefaults(options: IDxDefaultSettngsOptions) {
	dxTreeView.defaultOptions({
		options: {
			displayExpr: (item: string | IDxUiComponentItem | DxMultipleComponentItemType) => {
				const localizationService = options.localizationService;
				if (isString(item))
					return localizationService.translate(item);
				const captionsJoinString = options.captionsJoinString;
				if (isNil(item))
					return '';
				let keys = item as IDxUiComponentItem;
				if (isDxMultipleComponentItemWithTreeView(item))
					keys = item.dxTreeView;
				return computeCaption(keys, localizationService, captionsJoinString);
			},
			keyExpr: 'id'
		}
	});
}

function computeCaption(
	item: IDxUiComponentItem,
	localizationService: ILocalizationService,
	captionsJoinString: string | null | undefined
) {
	if (isNil(item))
		return '';
	const keys = item as IDxUiComponentItem;
	let caption = '';
	const captionCodes = keys.captionCode;
	if (isString(captionCodes))
		caption = localizationService.translate(captionCodes);
	else if (Array.isArray(captionCodes)) {
		if (isString(keys.captionsJoinString))
			captionsJoinString = keys.captionsJoinString;
		if (isNil(captionsJoinString))
			captionsJoinString = '-';
			caption = captionCodes.map(lk => localizationService.translate(lk)).join(captionsJoinString);
	}
	item.captionCode = caption;
	return caption;
}

